export default {
  props: ['choices', 'menuLabel', 'selected'],
  methods: {
    makeSelection(selected) {
      this.$emit('change', selected);
    },
  },
  template: `
    <div class="radio-group__container">
      <div class="radio-group__options">
        <label
          class="radio-group__option"
          :class="{'radio-group__option--selected': selected.value === option.value }"
          v-for="option in choices"
          @click="makeSelection(option)">
          <input type="radio" name="radio-group__option" :value="option.value" >
          <span>{{ option.value }}</span>
        </label>
      </div>
    </div>
  `,
};
